import SettingsContext from '@/shared/lib/context/settingsContext';
import { useContext } from 'react';

export const useSettings = () => useContext(SettingsContext);

export default useSettings;
